import React, { Component } from "react";
import classnames from "classnames";

import PropTypes from "prop-types";

export default class AvisosSmall extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired,
      };
    
      constructor(props) {
        super(props);
    
        this.state = {
        };
      }

    avisoClicked = () => {
    this.context.router.history.push("/comunidade/" + this.props.item._id);
  };

  render() {
    return (
      <div onClick={this.avisoClicked}  className="col-xs-12 col-md-6">
        <div
          className={classnames(
            "edital",
            "box-shadow",
            this.props.item.isActive ? "" : "inactive"
          )}
        >
          <h3
            className={
              this.props.item.type === "Aviso" ? "warning" : "communication"
            }
          >
            {this.props.item.title}
          </h3>
          
          <p>{this.props.item.smallDescription}</p>
        </div>
      </div>
    );
  }
}
